<template>
  <div class="relative">
        <div class="flex items-center">
            <input
                :ref="el => { input = el }"
                :id="id ? id : name"
                :type="type"
                :class="{
                    ['form-' + type] : type,
                    ['rounded-sm'] : type == 'checkbox',
                    [ inputClass ] : inputClass,
                    ['text-'+color+'-700 focus:ring-'+color+'-700'] : color && !disabled,
                    ['bg-gray-300 ring-gray-500 text-gray-700'] : disabled
                }"
                :name="name"
                :disabled="disabled"
                :readonly="readOnly"
                :value="value ? value : (modelValue ? modelValue : null)"
                :checked="isChecked(modelValue, value)"
                @input="updateValue($event)"
                v-if="mode == null"
            />
            <label
                v-if="label"
                :for="id ? id : name"
                :class="{
                    ['block font-semibold text-gray-700 ml-1'] : mode == null,
                    ['w-full p-2 rounded-md font-bold text-md flex items-center justify-between transition duration-300 cursor-pointer border-2'] : mode != null,
                    ['border-gray-900 bg-gray-900 text-gray-200 shadow-md'] : mode != null && modelValue == value,
                    ['bg-gray-200 hover:border-gray-300 text-gray-700 hover:bg-gray-300 hover:text-gray-700'] : mode != null && modelValue != value,
                }"
            >
            <div>
                <input
                    :ref="el => { input = el }"
                    :id="id ? id : name"
                    :type="type"
                    :class="{
                        ['form-' + type] : type,
                        ['rounded-sm'] : type == 'checkbox',
                        [ inputClass ] : inputClass,
                        ['text-'+color+'-700 focus:ring-'+color+'-700'] : color,
                    }"
                    class="w-5 h-5 -mt-0.5 transition duration-300"
                    :name="name"
                    :readonly="readOnly"
                    :value="value ? value : (modelValue ? modelValue : null)"
                    :checked="isChecked(modelValue, value)"
                    @input="updateValue($event)"
                    v-if="mode != null"
                />
                <span v-html="label"></span>
            </div>
                <slot name="addons"/>
            </label>
                <slot />
        </div>
        <div class="text-red-500 text-xs font-bold" v-if="errorMessage">{{ Array.isArray(errorMessage) ? errorMessage[0] : errorMessage }}</div>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity';
import {
    isBoolean,
    isChecked,
    inArray
} from 'helper';
import { watch } from '@vue/runtime-core';
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    props: {
        label: String,
        placeholder: String,
        inputClass: String,
        labelClass: String,
        type: {
            default: 'checkbox',
            type: String,
        },
        mode: {
            default: null,
            type: String,
        },
        disabled: Boolean,
        id: String,
        color: {
            type: String,
            default: 'red',
        },
        model: String,
        name: String,
        readOnly: [Boolean],
        maxLength: [String, Number],
        step: String,
        value: [String, Number, Boolean],
        data: [Array, Object],
        modelValue: {
            type:[String, Number, Boolean, Array, Object],
            default: ''
        },
        error: [String, Array],
        checked: Boolean,
    },
    emits: ['update:modelValue', 'update'],

    setup(props, { emit }) {
        const errorMessage = ref(props.error);
        const input = ref(null);

        const
            updateValue = (ev) => {
                if( (props.model && props.model == 'bool') || isBoolean(props.modelValue)){
                    let val = true;

                    if($(ev.target).is(':checked')) val = true;
                    else val = false;

                    emit('update:modelValue', val);

                } else {
                    if(Array.isArray(props.modelValue)) {
                        let arr = props.modelValue;
                        if(inArray(props.modelValue, null, props.value)) {

                            arr.splice(arr.indexOf(props.value), 1);
                            emit('update:modelValue', arr);
                        }
                        else {
                            arr.push(props.value);
                            emit('update:modelValue', arr);
                        }
                    }
                    else {
                        emit('update:modelValue', ev.target.value);
                    }
                }
                emit('update', ev);
                errorMessage.value = null;
            };

        watch( () => usePage().props.value.errors, (error, oldError) => {
            if(props.name || props.id) errorMessage.value = error[props.name ? props.name : props.id];
        })
        watch(() => props.modelValue, (val, oldVal) => {
            if(errorMessage.value && val != oldVal) errorMessage.value = null;
        })

        return {
            errorMessage,
            input,

            updateValue,
            isChecked
        }
    }
}
</script>
